// Yea no this is used. I don't think it works.
"use client"

import React, { createContext, useContext } from 'react';

const AppContext = createContext();

export function AppProviderContext({ children, baseUrl }) {
  return (
    <AppContext.Provider value={{ baseUrl }}>
      {children}
    </AppContext.Provider>
  );
}

export function useAppContext() {
  return useContext(AppContext);
}